import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Optimize Supabase Storage image URLs using the render endpoint
// Example input: https://<project>.supabase.co/storage/v1/object/public/bucket/path.webp
// Output:       https://<project>.supabase.co/storage/v1/render/image/public/bucket/path.webp?width=640&quality=70&resize=cover&format=webp
export function getOptimizedImageUrl(
  url?: string,
  width?: number,
  quality: number = 70,
  format: 'webp' | 'png' | 'jpg' = 'webp',
  resize: 'cover' | 'contain' | 'fill' | 'pad' | 'scale-down' = 'cover'
): string | undefined {
  if (!url) return url;
  
  try {
    const u = new URL(url);
    const isSupabase = u.hostname.includes('supabase.co') && u.pathname.includes('/storage/v1/object/public/');
    if (!isSupabase) return url;

    const path = u.pathname.replace('/storage/v1/object/', '/storage/v1/render/image/');
    const base = `${u.protocol}//${u.host}${path}`;
    const params = new URLSearchParams();
    if (width) params.set('width', String(width));
    params.set('quality', String(quality));
    params.set('resize', resize);
    params.set('format', format);
    return `${base}?${params.toString()}`;
  } catch {
    return url;
  }
}
